module.exports = __webpack_public_path__ + "static/media/ride.40c20b2a.svg";